import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { connect } from "react-redux";
import _ from "underscore";
import { useIntersection } from "../../Hooks/customHooks";
import { START_DRUG_LIST } from "../../Actions/PatientAction";
import {
  CircularProgress,
  Grid,
  TextField,
  ClickAwayListener,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../../Sass/Common.scss";
import Autocomplete from "@mui/material/Autocomplete";
import useViewport from "../../Hooks/useViewport";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      padding: "7.5px 108px 7.5px 6px !important",
      [theme.breakpoints.down("1300")]: {
        paddingRight: "0px !important",
      },
    },
  },
}));

function DrugAutoComplete(props) {
  const {
    value,
    multiple,
    disabled,
    handleChange,
    drugFieldList,
    getDrugFieldListAction,
    apiParams,
    disableEnter = true,
    maxValue,
    id,
    driverListFlag,
    helperText,
    error = false,
    maxVisibleChip = 2,
    excludeDrugs,
    patientInfoActionType,
    orderActionType,
    filterMedication,
    type,
    listOpen = false,
    prnDailogFlag = false,
    textFieldProps = {
      required: true,
    },
    ...other
  } = props;
  const classes = useStyles();
  const [selectDrug, setSelectDrug] = useState(value || {});
  const [drugSearchString, setDrugSearchString] = useState("");
  const [isOpenDrugList, setIsOpenDrugList] = useState(false);
  const [setTargetDrug, entryDrug] = useIntersection({
    threshold: 0.1,
  });
  const [drugPageCount, setDrugPageCount] = useState(0);
  /** handle get drug data */
  // useLayoutEffect(() => {
  //   if(Object.keys(drugFieldList?.data).length === 0){
  //     let params = {
  //       offset: 0,
  //       q: "",
  //     };
  //     getDrugFieldListAction(params);
  //     console.log("BACK UP DRUG API CALL CHECK");
  //   }
  // }, []);
  const [itemList, setItemList] = useState([]);
  const { width } = useViewport();
  /** get and set api data */
  useEffect(() => {
    let drugHas = [];
    let drugnothave = [];
    drugFieldList?.data?.list?.map((item) => {
      if (item.label.includes("(")) {
        drugHas.push(item);
      } else {
        drugnothave.push(item);
      }
    });
    let combinedArray = drugnothave.concat(drugHas);
    setItemList(combinedArray);
    if (
      patientInfoActionType === "patientInfo" ||
      orderActionType === "orderCreate"
    ) {
      const uniqueMeditation = combinedArray?.reduce(
        (accumulator, current) => {
          if (!filterMedication.find((item) => item.name === current.label)) {
            accumulator.push(current);
          }
          return accumulator;
        },
        [drugFieldList]
      );
      setItemList(uniqueMeditation);
    }
  }, [listOpen]);

  /**set the list data on page change */
  useEffect(() => {
    let drugHas = [];
    let drugnothave = [];
    drugFieldList?.data?.list?.map((item) => {
      if (item.label.includes("(")) {
        drugHas.push(item);
      } else {
        drugnothave.push(item);
      }
    });
    let combinedArray = drugnothave.concat(drugHas);
    const uniqueMeditation = combinedArray?.reduce(
      (accumulator, current) => {
        if (!filterMedication.find((item) => item.name === current.label)) {
          accumulator.push(current);
        }
        return accumulator;
      },
      [drugFieldList]
    );
    setItemList(uniqueMeditation);
  }, [drugFieldList?.data?.list]);

  /** fetch drug data */
  let fetchDrugData = async () => {
    console.log("fetchDrugData");
    setIsOpenDrugList(true);
    console.log(drugFieldList?.data?.list, "drugFieldList?.data?.list");
    if (!drugFieldList?.data?.list || drugFieldList?.data?.list?.length === 0) {
      let params = {
        offset: 0,
        q: "",
      };
      getDrugFieldListAction(params);
    }
  };

  /**set list open */
  useEffect(() => {
    if (listOpen === true) {
      if (prnDailogFlag === true) {
        fetchDrugData();
        return;
      } else {
        if (filterMedication[0].name === "") {
          setIsOpenDrugList(false);
        } else {
          fetchDrugData();
        }
      }
    }
  }, []);

  const handleClickAway = () => {
    if (width < 550) {
      return;
    } else {
      setIsOpenDrugList(false);
    }
  };

  /** get drug value  */
  useEffect(() => {
    if (multiple) {
      setSelectDrug(Object.values(value || {}));
    } else {
      setSelectDrug(value);
    }
  }, [value]);

  /** get drug on drug entry */
  useEffect(() => {
    if (entryDrug.isIntersecting && drugFieldList.loading === false) {
      if (isOpenDrugList) {
        //   let tempPageCount = drugPageCount + drugFieldList?.data?.list.length;
        //   setDrugPageCount(tempPageCount);
        //   let params = {
        //     offset: tempPageCount,
        //     q: drugSearchString,
        //   };
        //   getDrugFieldListAction(params);
        if(drugFieldList?.data?.list.length != drugFieldList?.data?.total) { 
          let params = {
            offset: drugFieldList?.data?.list.length,
            q: drugSearchString,
          };
          getDrugFieldListAction(params);
        }
      }
    }
  }, [entryDrug]);

  /** handle search */
  const searchDrugDebounce = useRef(
    _.debounce((searchString, open, otherStateValues = {}) => {
      if (open) {
        let params = {
          offset: 0,
          q: searchString,
        };
        getDrugFieldListAction(params);
      }
    }, 500)
  );

  /** handle search drug */
  const handleSearchDrugName = (newValue) => {
    setDrugSearchString(newValue);
    searchDrugDebounce.current(newValue, isOpenDrugList, {
      drug_ids: excludeDrugs,
    });
  };

  /** handle drug list change */
  const handleChangeDrugListing = (event, newValue) => {
    let newList = {};
    if (multiple) {
      newValue.map((group) => {
        newList[group.id] = group;
      });
    } else {
      newList = newValue;
    }
    setSelectDrug(newValue);
    handleChange && handleChange(newList);
  };
  return (
    <>
      <ClickAwayListener onClickAway={handleClickAway}>
        <Autocomplete
          multiple={multiple}
          classes={{
            option: "option",
            root: classes.root,
          }}
          id={id}
          disableCloseOnSelect={multiple}
          disabled={Boolean(disabled)}
          onOpen={fetchDrugData}
          open={isOpenDrugList}
          onClose={() => {
            setIsOpenDrugList(false);
          }}
          loading={drugFieldList?.loading}
          noOptionsText={"No results found"}
          value={selectDrug}
          onChange={handleChangeDrugListing}
          options={itemList || []}
          getOptionLabel={(option) => {
            return option?.name || "";
          }}
          isOptionEqualToValue={(option, value) => {
            return option?.id === value?.id;
          }}
          onInputChange={(event, newValue, reason) => {
            handleSearchDrugName(newValue);
          }}
          getOptionDisabled={(option) => {
            if (option.label === "No option found") {
              return true;
            }
          }}
          filterOptions={(option) => {
            let result = [...option];
            if (
              drugFieldList?.data?.list?.length < drugFieldList?.data?.total
            ) {
              result.push("FinalOption");
            }
            if (drugFieldList?.data?.list?.length === 0) {
              result.push({
                label: `No option found`,
              });
            }
            return result || [];
          }}
          renderOption={(props, option, { selected }) => {
            return (
              <React.Fragment>
                {typeof option === "object" ? (
                  <Grid {...props} key={option?.id}>
                    {option?.label}
                  </Grid>
                ) : (
                  <Grid className="autoCompleteInputLoader" ref={setTargetDrug}>
                    <CircularProgress size={20} />
                  </Grid>
                )}
              </React.Fragment>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              error={error}
              autoFocus
              id={id}
              helperText={helperText}
              InputLabelProps={{ required: false }}
              inputProps={{
                ...params.inputProps,
                autoComplete: "new-password",
                endAdornment: (
                  <React.Fragment>
                    {drugFieldList?.loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          {...other}
        />
      </ClickAwayListener>
    </>
  );
}

const mapStateToProps = (state) => ({
  drugFieldList: state.patient.drugFieldList,
});

const mapDispatchToProps = (dispatch) => ({
  getDrugFieldListAction: (payload) =>
    dispatch({ type: START_DRUG_LIST, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(DrugAutoComplete);
